import { render, staticRenderFns } from "./RepairCheckList.vue?vue&type=template&id=12868ef4&scoped=true&"
import script from "./RepairCheckList.vue?vue&type=script&lang=js&"
export * from "./RepairCheckList.vue?vue&type=script&lang=js&"
import style0 from "./RepairCheckList.vue?vue&type=style&index=0&id=12868ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12868ef4",
  null
  
)

export default component.exports